export const contactsData = {
    email: 'cody.tran23@gmail.com',
    phone: '(267) 774-3118',
    address: 'Philadelphia, PA, USA ',

    sheetAPI: "https://sheetdb.io/api/v1/nihqipjutf8jr"
}